import { useQuery } from '@tanstack/react-query';
import { frappePost } from '@/lib/frappe';

export const faqKeys = {
  all: ['faq'] as const,
  list: (category?: string) => [...faqKeys.all, 'list', category] as const,
};

export function useFAQs(category?: string) {
  return useQuery({
    queryKey: faqKeys.list(category),
    queryFn: async () => {
      // Backend returns { success, faqs: [...] }; unwrap to the array so call
      // sites can treat the result as a plain list (matches useFeaturedTeachers
      // pattern fixed in P0.3.10). Without this unwrap, FAQ.tsx calls .slice
      // on the envelope object and the whole tree errors into ErrorBoundary
      // during prerender — root cause of follow-up #38.
      const res = await frappePost<{ success?: boolean; faqs?: unknown[] } | unknown[]>(
        'hudan_lms.hudan_lms.doctype.hudan_faq.hudan_faq.get_faqs',
        category ? { category } : {},
        false
      );
      if (Array.isArray(res)) return res;
      return (res as { faqs?: unknown[] })?.faqs ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
